export default __webpack_public_path__ + "static/media/caret-down-small.51745573.svg";